/*
 *
 * DeliveryAdd constants
 *
 */

export const DEFAULT_ACTION = '/DeliveryAdd/DEFAULT_ACTION';
export const ADDRESS_PAYLOAD = {
  address_type: 'billing_address',
  address: {
    name: '',
    line: '',
    landmark: '',
    city: '',
    state: '',
    country: { id: '1243254', name: 'India' },
    zip_code: '',
    phone_numbers: [],
    email: '',
  },
};
export const UPDATE_ORDER_PAYLOAD = {
  skip_payable_validation: true,
  order: {
    shipping: {
      shipping_method: 'billing_address',
    },
    shipping_address: {},
    billing_address: {},
  },
};
export const FETCH_BILLING_ADDRESS = {
  address_type: 'billing_address',
};
export const MANDATORY_FIELDS = ['name', 'phone', 'address', 'zip_code', 'state', 'city'];



// WEBPACK FOOTER //
// client/containers/_DeliveryAdd/constants.js